const normalize = (text: string = "") =>
    text?.toString()?.toLowerCase()?.replace(/\s+/g, "")?.replace(/[^\w]/g, "")?.trim();

export const matchArea = (aiArea: string, context: any) => {
    if (!aiArea) return "";

    const found = context.areas.find((a: any) => normalize(a.label) === normalize(aiArea));

    return found ? found.value : "";
};

export const matchVillage = (aiVillages: string[], context: any) => {
    if (!Array.isArray(aiVillages)) return [];

    const matched = [];

    aiVillages.forEach((village) => {
        const found = context.villages.find((v: any) => normalize(v.label) === normalize(village));

        if (found) matched.push(found);
    });

    return matched;
};

export const matchRequestTypes = (aiRequestTypes: string[], context: any) => {
    if (!Array.isArray(aiRequestTypes)) return [];

    const matched = [];

    aiRequestTypes.forEach((request) => {
        const found = context.requestTypes.find((r: any) => normalize(r.name) === normalize(request));

        if (found) {
            matched.push({
                label: found.name,
                value: found.name,
                type: found.object.type,
                id: found.id,
            });
        }
    });

    return matched;
};

export const matchBooths = (aiBooths: string[], context: any) => {
    if (!Array.isArray(aiBooths)) return [];

    const matched = [];

    aiBooths.forEach((booth) => {
        const found = context.booths.find(
            (b: any) => normalize(String(b.boothNumber)) === normalize(String(booth))
        );

        if (found) {
            matched.push(found.object);
        }
    });

    return matched;
};
